import { useState, useEffect } from 'react';
import styles from './PromoModal.module.scss';

// Функция для скролла к форме
function scrollToSection(id) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export default function PromoModal() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Проверяем, показывали ли мы уже баннер
        const isShown = localStorage.getItem('promoGiftShown');
        if (isShown) return;

        let isTriggered = false; // Флаг, чтобы не вызвать дважды

        const showModal = () => {
            if (isTriggered) return;
            isTriggered = true;
            setIsVisible(true);
            localStorage.setItem('promoGiftShown', 'true'); // Запоминаем, что показали
            window.removeEventListener('scroll', handleScroll);
            document.body.style.overflow = 'hidden'; // Блокируем скролл сайта
        };

        // ТРИГГЕР 1: Показать через 40 секунд, если ничего не происходит
        const timeTimer = setTimeout(() => {
            showModal();
        }, 40000);

        // Защита от резкого показа после F5 (ждем 7 секунд, прежде чем слушать скролл)
        let canTriggerByScroll = false;
        const scrollDelayTimer = setTimeout(() => {
            canTriggerByScroll = true;
        }, 7000);

        // ТРИГГЕР 2: Скролл на 30%
        const handleScroll = () => {
            if (!canTriggerByScroll) return;

            const scrollY = window.scrollY;
            const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
            
            // Если проскроллили больше 30% (0.3)
            if (totalHeight > 0 && (scrollY / totalHeight) > 0.3) {
                showModal();
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Очистка при размонтировании
        return () => {
            clearTimeout(timeTimer);
            clearTimeout(scrollDelayTimer);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        document.body.style.overflow = '';
    };

    const handleAction = () => {
        handleClose();
        scrollToSection('form-section'); // Укажи правильный ID твоей формы
    };

    if (!isVisible) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.backdrop} onClick={handleClose}></div>
            
            <div className={styles.modal}>
                <button className={styles.closeBtn} onClick={handleClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <div className={styles.giftIcon}>🎁</div>
                
                <h2 className={styles.title}>
                    Поможем найти идеальное направление для вашего ребенка!
                </h2>
                
                <p className={styles.text}>
                    Мы видим, что вы заинтересовались нашей школой. Запишитесь на <b>первое занятие</b> уже сейчас и получите <i>скидку -700руб на первый месяц обучения!</i> в подарок!
                </p>

                <button className={styles.ctaBtn} onClick={handleAction}>
                    Забрать подарок и записаться
                </button>
            </div>
        </div>
    );
}
